const transliterate = (text) => {
  const dictionary = {
    а: "a",
    б: "b",
    в: "v",
    г: "h",
    д: "d",
    е: "e",
    є: "ie",
    ж: "zh",
    з: "z",
    и: "y",
    і: "i",
    ї: "i",
    й: "i",
    к: "k",
    л: "l",
    м: "m",
    н: "n",
    о: "o",
    п: "p",
    р: "r",
    с: "s",
    т: "t",
    у: "u",
    ф: "f",
    х: "kh",
    ц: "ts",
    ч: "ch",
    ш: "sh",
    щ: "shch",
    ю: "iu",
    я: "ia",
  };

  return text
    .split("")
    .map((char) => dictionary[char] || char)
    .join("");
};

export default transliterate;
